import { CheckCircle, MapPin, Phone, ArrowRight, Building2, ShoppingBag, Sparkles, Truck, Factory, TrendingUp } from "lucide-react";

const ServiceLocations = () => {
  const cities = [
    {
      name: "Mumbai",
      state: "Maharashtra",
      description: "As India's financial capital and fashion hub, Mumbai houses thousands of D2C brands, fashion labels, and FMCG companies looking to expand their digital footprint. BrandBorn serves as the trusted ecommerce onboarding agency in Mumbai, helping local brands get listed on Myntra, Nykaa, and Ajio with streamlined documentation and fast approvals.",
      industries: ["Fashion & Apparel", "Beauty & Cosmetics", "FMCG"],
      highlight: "Home to India's largest fashion industry cluster"
    },
    {
      name: "Surat",
      state: "Gujarat",
      description: "Known as the textile capital of India, Surat is home to thousands of textile manufacturers and fashion entrepreneurs. Our ecommerce onboarding agency in Surat specializes in helping local textile businesses transition to online marketplaces. Whether you're a saree manufacturer or ethnic wear brand, BrandBorn helps Surat-based brands sell on Myntra, Ajio, and other premium platforms.",
      industries: ["Textiles", "Ethnic Wear", "Fashion Manufacturing"],
      highlight: "India's textile manufacturing hub"
    },
    {
      name: "Delhi NCR",
      state: "Delhi",
      description: "The Delhi NCR region, including Noida, Gurgaon, and Faridabad, is a powerhouse of D2C brands and established FMCG companies. As a leading Myntra onboarding consultant in Delhi, BrandBorn has helped hundreds of brands from this region launch on premium marketplaces. Our Delhi team specializes in quick commerce onboarding for Blinkit and Swiggy Instamart.",
      industries: ["D2C Brands", "FMCG", "Beauty"],
      highlight: "India's startup and D2C capital"
    },
    {
      name: "Pune",
      state: "Maharashtra",
      description: "Pune's thriving startup ecosystem and proximity to Mumbai make it an emerging hub for D2C brands. Our Blinkit supplier onboarding services in Pune help local FMCG brands tap into the quick commerce revolution. From organic food brands to personal care startups, BrandBorn serves as the go-to marketplace onboarding partner in Pune.",
      industries: ["Organic & Health Foods", "Personal Care", "Startups"],
      highlight: "Emerging D2C and startup hub"
    },
    {
      name: "Ludhiana",
      state: "Punjab",
      description: "Ludhiana is India's knitwear and hosiery capital, with manufacturers supplying to brands across the country. BrandBorn provides specialized Ajio brand onboarding services in Ludhiana, helping local manufacturers establish their own brand presence on premium marketplaces. Our team understands the unique challenges faced by Punjab-based manufacturers transitioning to D2C.",
      industries: ["Knitwear", "Hosiery", "Winter Wear"],
      highlight: "India's knitwear manufacturing capital"
    },
    {
      name: "Chandigarh",
      state: "Punjab/Haryana",
      description: "As the shared capital of Punjab and Haryana, Chandigarh serves as a commercial hub for brands from both states. Our ecommerce consulting services in Chandigarh cater to fashion brands, beauty startups, and FMCG companies looking to expand online. BrandBorn helps Chandigarh-based brands navigate Nykaa seller onboarding and Myntra registration with ease.",
      industries: ["Fashion", "Beauty", "Regional FMCG"],
      highlight: "Gateway to North Indian markets"
    },
    {
      name: "Noida",
      state: "Uttar Pradesh",
      description: "Part of the Delhi NCR, Noida has emerged as a major hub for D2C brands and quick commerce operations. Our Swiggy Instamart vendor registration services in Noida help local brands tap into the 10-minute delivery ecosystem. BrandBorn's Noida team specializes in both marketplace and quick commerce onboarding.",
      industries: ["D2C", "Quick Commerce", "Electronics"],
      highlight: "Quick commerce operations hub"
    },
    {
      name: "Gurgaon",
      state: "Haryana",
      description: "Gurgaon (Gurugram) is home to numerous corporate headquarters and D2C brand offices. As a marketplace onboarding expert in Gurgaon, BrandBorn serves brands ranging from fashion startups to established FMCG companies. Our proximity to major quick commerce dark stores makes us the ideal partner for Blinkit and Swiggy Instamart onboarding.",
      industries: ["Corporate D2C", "Fashion Tech", "FMCG"],
      highlight: "Corporate and D2C brand headquarters"
    },
    {
      name: "Ahmedabad",
      state: "Gujarat",
      description: "Gujarat's commercial capital, Ahmedabad, is home to textile traders, pharmaceutical companies, and emerging D2C brands. BrandBorn's ecommerce onboarding services in Ahmedabad help local businesses expand to national marketplaces. From traditional textile businesses to modern beauty brands, we guide Gujarat-based entrepreneurs through the marketplace journey.",
      industries: ["Textiles", "Pharmaceuticals", "Traditional Wear"],
      highlight: "Gujarat's commercial capital"
    },
    {
      name: "Jaipur",
      state: "Rajasthan",
      description: "The Pink City is renowned for its handicrafts, jewelry, and ethnic fashion. BrandBorn helps Jaipur-based artisans and brands reach national audiences through Myntra and Ajio onboarding. Our expertise in ethnic wear marketplace positioning makes us the preferred choice for Rajasthani fashion entrepreneurs.",
      industries: ["Handicrafts", "Ethnic Fashion", "Jewelry"],
      highlight: "Handicraft and ethnic fashion hub"
    },
    {
      name: "Bangalore",
      state: "Karnataka",
      description: "India's Silicon Valley is also a hotbed for D2C startups and premium fashion brands. BrandBorn provides expert marketplace onboarding in Bangalore for tech-savvy entrepreneurs. From health food startups to athleisure brands, our Bangalore team specializes in Myntra, Nykaa, and Blinkit onboarding.",
      industries: ["D2C Startups", "Health Foods", "Athleisure"],
      highlight: "India's startup capital"
    },
    {
      name: "Hyderabad",
      state: "Telangana",
      description: "Hyderabad's booming tech economy and growing fashion industry make it a key market. BrandBorn helps Hyderabad brands get listed on Myntra, Nykaa, and quick commerce platforms. From pearl jewelry to IT-backed D2C brands, we provide complete marketplace onboarding services in Hyderabad.",
      industries: ["Fashion", "Jewelry", "Tech D2C"],
      highlight: "Emerging fashion and tech hub"
    },
    {
      name: "Chennai",
      state: "Tamil Nadu",
      description: "Chennai's thriving textile and manufacturing industry feeds into India's e-commerce ecosystem. BrandBorn provides expert ecommerce onboarding services in Chennai, helping silk saree manufacturers, beauty brands, and FMCG companies sell on Myntra, Nykaa, and Ajio.",
      industries: ["Silk Textiles", "Beauty", "FMCG"],
      highlight: "South India's manufacturing hub"
    },
    {
      name: "Kolkata",
      state: "West Bengal",
      description: "The cultural capital of India, Kolkata is home to legendary fashion houses and emerging D2C brands. BrandBorn's marketplace onboarding services in Kolkata help local saree brands, beauty startups, and food companies expand to national platforms like Myntra, Nykaa, and Blinkit.",
      industries: ["Sarees", "Sweets & Food", "Fashion"],
      highlight: "Eastern India's cultural commerce hub"
    },
    {
      name: "Indore",
      state: "Madhya Pradesh",
      description: "Indore is rapidly emerging as Central India's business hub with growing D2C brands and FMCG companies. BrandBorn provides marketplace onboarding in Indore for food brands, textile businesses, and quick commerce sellers on Blinkit and Zepto.",
      industries: ["Food & Snacks", "Textiles", "FMCG"],
      highlight: "Central India's fastest growing city"
    },
    {
      name: "Lucknow",
      state: "Uttar Pradesh",
      description: "Famous for Chikankari embroidery and Nawabi fashion, Lucknow's artisan brands deserve national exposure. BrandBorn helps Lucknow-based fashion and food brands onboard on Myntra, Ajio, and Swiggy Instamart with expert marketplace services.",
      industries: ["Chikankari Fashion", "Food", "Handicrafts"],
      highlight: "Chikankari and heritage fashion hub"
    },
    {
      name: "Coimbatore",
      state: "Tamil Nadu",
      description: "Coimbatore is a key textile and manufacturing hub in South India. BrandBorn provides marketplace onboarding services in Coimbatore for cotton textile brands, wellness products, and FMCG companies looking to sell on Myntra, Amazon, and Blinkit.",
      industries: ["Cotton Textiles", "Wellness", "Manufacturing"],
      highlight: "South India's textile powerhouse"
    },
    {
      name: "Nagpur",
      state: "Maharashtra",
      description: "Central India's Orange City is seeing rapid growth in D2C brands and food companies. BrandBorn helps Nagpur-based brands get listed on Blinkit, Zepto, Amazon and Flipkart with fast-track marketplace onboarding.",
      industries: ["Food Products", "Agriculture", "D2C"],
      highlight: "Central India's distribution hub"
    },
    {
      name: "Kanpur",
      state: "Uttar Pradesh",
      description: "Known as India's leather capital, Kanpur is home to thousands of leather goods manufacturers. BrandBorn helps Kanpur's leather brands, fashion labels, and FMCG companies sell on Myntra, Ajio, Amazon, and quick commerce platforms.",
      industries: ["Leather Goods", "Fashion", "FMCG"],
      highlight: "India's leather manufacturing capital"
    },
    {
      name: "Rajkot",
      state: "Gujarat",
      description: "Rajkot's growing manufacturing and business community is eager to sell online. BrandBorn provides expert ecommerce onboarding in Rajkot for textile brands, traditional wear companies, and food product manufacturers.",
      industries: ["Textiles", "Traditional Wear", "Food"],
      highlight: "Gujarat's emerging business hub"
    },
    {
      name: "Tirupur",
      state: "Tamil Nadu",
      description: "Tirupur is India's knitwear export capital with thousands of garment manufacturers. BrandBorn helps Tirupur's garment brands sell directly on Myntra, Ajio, and Amazon through expert marketplace onboarding and AI catalog creation via ecomcatalog.ai.",
      industries: ["Knitwear", "Garments", "Cotton Wear"],
      highlight: "India's knitwear export capital"
    },
    {
      name: "Varanasi",
      state: "Uttar Pradesh",
      description: "The holy city of Varanasi is world-famous for Banarasi silk sarees and traditional textiles. BrandBorn helps Varanasi's weaver communities and silk brands reach national markets through Myntra and Ajio onboarding.",
      industries: ["Banarasi Silk", "Handloom", "Traditional Wear"],
      highlight: "Banarasi silk and handloom capital"
    },
    {
      name: "Panipat",
      state: "Haryana",
      description: "Known as the City of Weavers, Panipat is India's home textile capital. BrandBorn provides marketplace onboarding for Panipat's blanket, carpet, and home furnishing brands on Amazon, Flipkart, Pepperfry, and Myntra Home.",
      industries: ["Home Textiles", "Blankets", "Carpets"],
      highlight: "India's home textile capital"
    }
  ];

  const platforms = [
    {
      name: "Myntra",
      icon: "M",
      color: "from-pink-500 to-rose-500",
      description: "India's largest fashion marketplace with 50M+ monthly users. We help fashion, beauty, and lifestyle brands get approved and selling on Myntra within 14-21 days.",
      services: ["Seller Registration", "Brand Verification", "Catalog Management", "Listing Optimization"]
    },
    {
      name: "Nykaa",
      icon: "N",
      color: "from-rose-500 to-pink-600",
      description: "The premier beauty destination for Indian consumers. Our Nykaa seller onboarding services cover everything from documentation to compliance for beauty and personal care brands.",
      services: ["Brand Onboarding", "Product Compliance", "Catalog Setup", "Account Management"]
    },
    {
      name: "Ajio",
      icon: "A",
      color: "from-gray-700 to-gray-900",
      description: "Reliance's fashion powerhouse with a focus on ethnic and premium fashion. BrandBorn specializes in Ajio brand onboarding for manufacturers and fashion entrepreneurs.",
      services: ["Seller Panel Registration", "Brand Authorization", "Quality Verification", "Launch Support"]
    },
    {
      name: "Blinkit",
      icon: "B",
      color: "from-yellow-400 to-orange-500",
      description: "India's leading 10-minute delivery platform. Our Blinkit supplier onboarding services help FMCG brands tap into the quick commerce revolution.",
      services: ["Vendor Registration", "Dark Store Listing", "Inventory Setup", "Growth Strategy"]
    },
    {
      name: "Swiggy Instamart",
      icon: "S",
      color: "from-orange-500 to-red-500",
      description: "Quick commerce backed by Swiggy's massive user base. We handle Swiggy Instamart vendor registration and help brands scale in the instant delivery ecosystem.",
      services: ["Supplier Registration", "Product Listing", "Warehouse Coordination", "Performance Optimization"]
    }
  ];

  const industries = [
    { name: "Fashion & Apparel", icon: ShoppingBag, description: "From ethnic wear to western fashion, we help clothing brands succeed on Myntra and Ajio." },
    { name: "Beauty & Cosmetics", icon: Sparkles, description: "Specialized Nykaa onboarding for skincare, makeup, and personal care brands." },
    { name: "FMCG & Groceries", icon: Truck, description: "Quick commerce expertise for food, beverages, and household products on Blinkit and Instamart." },
    { name: "Textiles & Manufacturing", icon: Factory, description: "Helping textile manufacturers from Surat and Ludhiana build their own brand presence." },
    { name: "D2C Startups", icon: TrendingUp, description: "End-to-end marketplace strategy for direct-to-consumer brands scaling nationally." },
    { name: "Regional Brands", icon: Building2, description: "Transforming regional businesses into national brands through strategic marketplace presence." }
  ];

  const faqs = [
    {
      question: "Do you provide onboarding services outside Mumbai?",
      answer: "Absolutely! BrandBorn serves brands across India, including Mumbai, Delhi, Pune, Surat, Ludhiana, Chandigarh, Noida, Gurgaon, Ahmedabad, and many more cities. Our remote onboarding process is designed to work seamlessly with brands from any location. We have successfully onboarded brands from tier-2 and tier-3 cities onto premium marketplaces."
    },
    {
      question: "Can brands from Surat get onboarded on Myntra?",
      answer: "Yes! Surat-based textile and fashion brands are among our specialty. We understand the unique strengths of Surat's textile industry and help local manufacturers and brands successfully list on Myntra, Ajio, and other fashion marketplaces. Our team handles everything from documentation to catalog creation, ensuring Surat brands meet all platform requirements."
    },
    {
      question: "Do you help Punjab-based manufacturers sell on quick commerce?",
      answer: "Yes, we work extensively with manufacturers from Punjab, including Ludhiana and other industrial hubs. For quick commerce platforms like Blinkit and Swiggy Instamart, we help FMCG manufacturers and distributors from Punjab set up their vendor accounts, manage inventory listings, and optimize for the 10-minute delivery model."
    },
    {
      question: "What's the onboarding timeline for brands outside metro cities?",
      answer: "The onboarding timeline remains consistent regardless of your location. With BrandBorn, brands from any city can expect to go live within 14-21 days for fashion marketplaces and 10-15 days for quick commerce platforms. Our digital-first approach ensures location doesn't impact speed or quality of service."
    },
    {
      question: "Do you offer in-person consultations in these cities?",
      answer: "While our primary operations are remote for efficiency, we do offer virtual consultations and can arrange in-person meetings for enterprise clients in major cities. Our video consultation process is comprehensive and has helped 1000+ brands successfully onboard without requiring physical meetings."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-20 px-4 bg-gradient-to-br from-gray-50 via-white to-red-50/30 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-red-500 rounded-full filter blur-3xl" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500 rounded-full filter blur-3xl" />
        </div>
        
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-full text-sm font-bold mb-6">
              <MapPin size={16} />
              <span>SERVING BRANDS PAN INDIA</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Best Ecommerce & Quick Commerce Onboarding Agency{" "}
              <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
                Serving Brands Across India
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto mb-8 leading-relaxed">
              From Mumbai to Ludhiana, Surat to Delhi – BrandBorn helps brands from every corner of India 
              get listed on Myntra, Nykaa, Ajio, Blinkit, and Swiggy Instamart. 1000+ brands launched. 
              98% approval rate. Your location doesn't limit your marketplace ambitions.
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-8">
              {["Surat", "Mumbai", "Delhi", "Pune", "Gujarat", "Punjab", "Haryana", "Noida", "Gurgaon", "Ludhiana", "Chandigarh"].map((city) => (
                <span key={city} className="px-3 py-1 bg-white rounded-full text-sm font-medium text-gray-700 border border-gray-200 shadow-sm">
                  {city}
                </span>
              ))}
            </div>

            <a 
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-2xl font-bold text-lg shadow-xl shadow-red-500/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              Get Free Consultation
              <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </section>

      {/* City-wise Services Section */}
      <section className="py-16 md:py-24 px-4 bg-white" id="cities">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Marketplace Onboarding Support in Major Indian Cities
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We understand the unique business landscape of each region. Our city-specific expertise 
              helps local brands navigate marketplace requirements effectively.
            </p>
          </div>

          <div className="space-y-6">
            {cities.map((city, idx) => (
              <div 
                key={idx}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 border border-gray-100 hover:shadow-lg transition-shadow duration-300"
                id={city.name.toLowerCase().replace(/\s+/g, '-')}
              >
                <div className="flex flex-col md:flex-row md:items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-red-500 to-orange-500 flex items-center justify-center text-white shadow-lg">
                      <MapPin size={28} />
                    </div>
                  </div>
                  <div className="flex-grow">
                    <div className="flex flex-wrap items-center gap-3 mb-3">
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900">
                        Ecommerce Onboarding Agency in {city.name}
                      </h3>
                      <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-semibold">
                        {city.state}
                      </span>
                    </div>
                    <p className="text-sm text-orange-600 font-medium mb-3">{city.highlight}</p>
                    <p className="text-gray-600 leading-relaxed mb-4">{city.description}</p>
                    <div className="flex flex-wrap gap-2">
                      {city.industries.map((industry, i) => (
                        <span key={i} className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
                          {industry}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Platforms Section */}
      <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-gray-50 to-white" id="platforms">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Platforms We Help You Sell On
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              From fashion marketplaces to quick commerce – we cover all major platforms where 
              Indian consumers shop.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {platforms.map((platform, idx) => (
              <div 
                key={idx}
                className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-xl transition-all duration-300"
              >
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-r ${platform.color} flex items-center justify-center text-white font-bold text-2xl mb-4 shadow-lg`}>
                  {platform.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{platform.name} Onboarding</h3>
                <p className="text-gray-600 text-sm mb-4">{platform.description}</p>
                <ul className="space-y-2">
                  {platform.services.map((service, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-gray-700">
                      <CheckCircle className="w-4 h-4 text-green-500" />
                      {service}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="py-16 md:py-24 px-4 bg-white" id="industries">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Industries We Work With
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Whether you're a textile manufacturer from Surat or a D2C startup from Gurgaon, 
              we have the expertise to launch your brand successfully.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industries.map((industry, idx) => (
              <div 
                key={idx}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-100 hover:border-red-200 transition-colors duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-red-500 to-orange-500 flex items-center justify-center mb-4">
                  <industry.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{industry.name}</h3>
                <p className="text-gray-600 text-sm">{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose BrandBorn */}
      <section className="py-16 md:py-24 px-4 bg-gradient-to-r from-red-500 to-orange-500 text-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
              Why Brands Across India Choose BrandBorn
            </h2>
            <p className="text-lg text-white/80 max-w-3xl mx-auto">
              From tier-1 cities to emerging markets, we've helped 1000+ brands successfully 
              launch on premium marketplaces.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { stat: "1000+", label: "Brands Launched", desc: "Across all major Indian cities" },
              { stat: "98%", label: "Approval Rate", desc: "First-time success guaranteed" },
              { stat: "14", label: "Days to Launch", desc: "Fastest in the industry" },
              { stat: "50+", label: "Cities Served", desc: "True pan-India coverage" }
            ].map((item, idx) => (
              <div key={idx} className="text-center p-6 bg-white/10 rounded-2xl backdrop-blur-sm">
                <div className="text-4xl md:text-5xl font-black mb-2">{item.stat}</div>
                <div className="font-bold mb-1">{item.label}</div>
                <div className="text-sm text-white/70">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-16 md:py-24 px-4 bg-white" id="faqs">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600">
              Common questions about our pan-India marketplace onboarding services
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div 
                key={idx}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-100"
              >
                <h3 className="text-lg font-bold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Ready to Launch Your Brand on Premium Marketplaces?
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Whether you're in Mumbai, Surat, Delhi, Ludhiana, or any other city – BrandBorn 
            is your trusted partner for marketplace success. Get started with a free consultation today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/#contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              Get Free Consultation
              <ArrowRight size={20} />
            </a>
            <a 
              href="tel:+919464645491"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-900 rounded-2xl font-bold text-lg hover:bg-gray-100 transition-colors"
            >
              <Phone size={20} />
              +91-9464645491
            </a>
          </div>

          <p className="mt-8 text-gray-400 text-sm">
            Serving brands in Surat | Mumbai | Delhi | Pune | Gujarat | Punjab | Haryana | Noida | Gurgaon | Ludhiana | Chandigarh | Ahmedabad | Jaipur | and 50+ more cities
          </p>
        </div>
      </section>
    </div>
  );
};

export default ServiceLocations;
